import Converter from './Converter';
import { shortLanguages } from 'services/locale';
import { CasinoType, ICasinoProviderConfigurationItem } from 'modules/Casino/types/configuration';
import { projectName } from 'modules/Casino/utils/slots';
import { parseCookies } from '../../utils/parseCookies';
import { QueryTypes } from 'modules/Casino/types/enums/api';

const converter = new Converter();

export const config: ICasinoProviderConfigurationItem<Converter> = {
  type: CasinoType.liveCasino,
  authRequired: false,
  gameListUrl: `amusnet/game/list`,
  converter,
  getHeaders: () => ({
    'Content-Type': 'application/json',
    headers: { 'x-partner-name': projectName },
  }),
  sessionUrlData: {
    url: 'amusnet/game/launch',
    getQuery: params => `device=${params.platform === 'mobile' ? 'mobile' : 'desktop'}&list_of=games`,
    method: QueryTypes.GET,
    converter: converter.convertGameUrl,
    getBody: params => ({
      game_id: params.id,
      lang: shortLanguages[params.lang as keyof typeof shortLanguages],
      device: params.isDesktop ? 'desktop' : 'mobile',
    }),
    getHeaders: () => ({
      headers: {
        'x-partner-authorization': parseCookies(),
        'x-partner-name': projectName,
      },
    }),
  },
};
